import React from "react";
import { icons } from "lucide-react";
import { cn } from "@/lib/utils";
import { getCategoryTheme } from "@/lib/categoryTheme";

interface DynamicIconProps {
  name: string;
  className?: string;
  style?: React.CSSProperties;
}

export function DynamicIcon({ name, className, style }: DynamicIconProps) {
  if (!name) return null;

  // 1. Direct Lucide icon key match (e.g. "Cpu", "TrendingUp")
  const DirectIcon = icons[name as keyof typeof icons];
  if (DirectIcon) {
    return <DirectIcon className={cn("w-5 h-5", className)} style={style} />;
  }

  // 2. PascalCase conversion (e.g. "trending-up" -> "TrendingUp")
  const pascalName = name
    .split(/[-_\s]+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join("");
  const PascalIcon = icons[pascalName as keyof typeof icons];
  if (PascalIcon) {
    return <PascalIcon className={cn("w-5 h-5", className)} style={style} />;
  }

  // 3. Category theme mapping (e.g. "technology" -> Cpu)
  const categoryTheme = getCategoryTheme(name);
  if (categoryTheme) {
    const CategoryIcon = categoryTheme.Icon;
    return <CategoryIcon className={cn("w-5 h-5", className)} style={style} />;
  }

  const Fallback = icons.Tag || icons.Hash;
  return <Fallback className={cn("w-5 h-5", className)} style={style} />;
}
